<template>
  <div class="monthlyReport hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item
          label="查询日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            type="month"
            placeholder="选择日期"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" :loading="loading"/>
    <!-- 表格 -->
    <monthlyReport
      ref="monthlyReport"
      :table-data="tableData"
    />
    <br>
    <br>
    <monthlyHistoricalSincerityGold
      ref="monthlyHistoricalSincerityGold"
      :query="query"
    />
    <br>
    <br>
    <monthlyPositionSummary
      ref="monthlyPositionSummary"
      :query="query"
    />
    <br>
    <br>
    <monthlyClosingSummary
      ref="monthlyClosingSummary"
      :query="query"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'
import monthlyReport from './components/monthly-report'
import monthlyHistoricalSincerityGold from './components/monthly-historical-sincerity-gold'
import monthlyPositionSummary from './components/monthly-position-summary'
import monthlyClosingSummary from './components/monthly-closing-summary'

function Query () {
  this.marketId = '000' // 组织
  this.date = new Date() // 日期
}
export default {
  name: 'Index',
  components: {
    monthlyReport,
    monthlyHistoricalSincerityGold,
    monthlyPositionSummary,
    monthlyClosingSummary
  },
  data () {
    return {
      query: new Query(),
      currentPage: 1,
      total: 0,
      pageSize: 10,
      tableData: {}, // 表格数据
      marketId: '',
      monthDate: '',
      loading: false,
    }
  },
  mounted () {
    // 分页查询
    this.fetchList()
    this.getUserInfo() // 获取用户信息
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (!this.query.date) {
        this.$message.error('日期必选')
        return
      }
      this.marketId = this.query.marketId
      this.monthDate = dayJs(this.query.date).format('YYYYMM')
      this.$refs.monthlyHistoricalSincerityGold.fetchList(currentPage, pageSize)
      this.$refs.monthlyPositionSummary.fetchList(currentPage, pageSize)
      this.$refs.monthlyClosingSummary.fetchList(currentPage, pageSize)
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 导出
    toDownload () {
      if (!this.query.date) {
        this.$message.error('日期必选')
        return
      }
      this.$store.commit('setHeaderToLS')
      let param = {
        marketId: this.marketId,
        monthDate: this.monthDate,
        excelHeadList: [
          {
            execlType: '01',
            excelHead: this.$store.state.exportConfig.hisHeader['月报表_月历史诚意金']
          },
          {
            execlType: '02',
            excelHead: this.$store.state.exportConfig.hisHeader['月报表_月持仓汇总']
          },
          {
            execlType: '03',
            excelHead: this.$store.state.exportConfig.hisHeader['月报表_月成交汇总']
          }
        ]
      }
      this.loading = true
      this.$utils.getExcelFile(this, api.monthlyReportExport, param, () => {
        this.loading = false
      })
    },
    async getUserInfo () {
      let marketCodes = this.$store.state.user.info.marketCodes
      if (!marketCodes || marketCodes.length < 0) return // 不存在市场
      let marketIds = marketCodes[0]
      for (let i = 1; i < marketCodes.length; i++) {
        marketIds = marketIds + ',' + marketCodes[i]
      }
      let param = {
        marketIds
      }
      await api.spotPurchaseSaleInquiry.MarketInfo(param).then((res) => {
        this.tableData = res // 获取市场名称
        this.tableData.marketName = res.data ? res.data[0].marketName : ''
        this.tableData.userName = this.$store.state.user.info.userName // 获取客户名称
        this.tableData.userAccount = this.$store.state.user.info.userAccount
      })
    }
  }
}

</script>
<style lang="scss" scoped>
  // 按钮对齐搜索框
  ::v-deep .table-page-search-submitButtons {
    margin-left: 100px
  }

  .red {
    color: red
  }

  .monthlyReport ::v-deep .report_title {
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;

    .report-line {
      margin-left: 10px;
    }
  }

  .monthlyReport ::v-deep .z-table__content {
    min-height: inherit !important
  }

  .monthlyReport ::v-deep .el-table thead.is-group th {
    background: none;
    border-right: none;
  }

  .monthlyReport ::v-deep .el-table__row td {
    border-right: none
  }

  ::v-deep .report-line {
    width: 4px;
    height: 14px;
    background-color: #f8bd47;
    display: inline-block;
    vertical-align: middle;
  }

  ::v-deep .report-title {
    color: #333333;
    height: 40px;
    font-weight: bold;
    font-size: 14px;
    margin-left: 10px;
    vertical-align: middle
  }

  ::v-deep .report-title+span {
    float: right;

    button {
      height: 34px;
      padding: 0 20px;
    }
  }

  // 导出配置组件样式
  ::v-deep .export_config {
    float: right;
    margin-top: 3px;
  }

</style>
